import {
    REQUEST_ORDERS_POSTED,
    REQUEST_ORDERS_POSTED_FAILURE,
    REQUEST_ORDERS_POSTED_SUCCESS
} from "../../../constant/transaction/OrderConstant";


const initialState = {
    ordersPosted: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const ordersPostedReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ORDERS_POSTED:
            return {
                ...state,
                ordersPosted: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ORDERS_POSTED_SUCCESS:
            return {
                ...state,
                ordersPosted: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ORDERS_POSTED_FAILURE:
            return {
                ...state,
                ordersPosted: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
